import { render, staticRenderFns } from "./WavesBackgroundBottom.vue?vue&type=template&id=da89e32c"
import script from "./WavesBackgroundBottom.vue?vue&type=script&lang=js"
export * from "./WavesBackgroundBottom.vue?vue&type=script&lang=js"
import style0 from "./WavesBackgroundBottom.vue?vue&type=style&index=0&id=da89e32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports